import {UtilSelector} from '../Core/Utils/UtilSelector.js';
import {ProjectSettings} from '../ProjectSettings.js';

class VideoCols {
    #desktopBreakpoint;
    constructor() {
        this.#desktopBreakpoint = UtilSelector.getRootVar('desktop-breakpoint', ProjectSettings.rootVarPrefix);
    }

    init() {
        let videoColsElements = document.querySelectorAll('.vowe-element-video-cols');
        this.#initVideoColsDesktop(videoColsElements);
        this.#initVideoColsMobile(videoColsElements);
    }

    #initVideoColsDesktop(videoColsElements) {
        videoColsElements.forEach(videoColsElement => {
            let videoColElements = videoColsElement.querySelectorAll('.video-col');
            videoColElements.forEach(videoColElement => {
                videoColElement.addEventListener('mouseenter', () => {
                    if (UtilSelector.mediaMinWidth(this.#desktopBreakpoint)) {
                        this.#activateVideo(videoColElement);
                    }
                });
            });
            videoColsElement.addEventListener('mouseleave', () => {
                if (UtilSelector.mediaMinWidth(this.#desktopBreakpoint)) {
                    this.#deactivateVideos(videoColsElement);
                }
            });
        });
    }

    #initVideoColsMobile(videoColsElements) {
        videoColsElements.forEach(videoColsElement => {
            let videoColElements = videoColsElement.querySelectorAll('.video-col');
            videoColElements.forEach(videoColElement => {
                videoColElement.addEventListener('click', () => {
                    if (!UtilSelector.mediaMinWidth(this.#desktopBreakpoint)) {
                        this.#activateVideo(videoColElement);
                    }
                });
            });
            
            //pause videos on click outside
            document.addEventListener('click', (event) => {
                if (!UtilSelector.mediaMinWidth(this.#desktopBreakpoint)) {
                    if (event.target.closest('.vowe-element-video-cols') !== videoColsElement) {
                        this.#deactivateVideos(videoColsElement);
                    }
                }
            });
        });
    }

    #deactivateVideos(videoColsElement) {
        let videoColElements = videoColsElement.querySelectorAll('.video-col');
        videoColElements.forEach(videoColElement => {
            videoColElement.classList.remove('active');
            videoColElement.querySelector('video').pause();
        });
    }

    #activateVideo(videoColElement) {
        videoColElement.classList.add('active');
        let relatedVideoColElements = videoColElement.closest('.vowe-element-video-cols').querySelectorAll('.video-col');
        relatedVideoColElements.forEach(relatedVideoColElement => {
            if (relatedVideoColElement !== videoColElement) {
                relatedVideoColElement.classList.remove('active');
                relatedVideoColElement.querySelector('video').pause();
            }
        });
        videoColElement.querySelector('video').play();
    }
}

export {VideoCols};